import {HttpAxiosRequest} from "../httpAxiosBase";
import {AmortizationType} from "../../types/operationData";

export const HttpCacheAmortization = {
    getEndpoint: (url: string): string => `cache/sistema-amortizacion${url}`,

    getAmortizationTypes: (): Promise<AmortizationType[]> => {
        return HttpAxiosRequest.get(
            HttpCacheAmortization.getEndpoint('')
        );
    },
}